<template>
  <div :class="{ fullWidthLayout: $route.meta.fullWidthLayout }">
    <public-status-page-nav-bar></public-status-page-nav-bar>

    <div
      class="main-content"
      @click="$sidebar.displaySidebar(false)"
      :class="{
        loggedin: userLoggedIn
      }"
    >
      <fade-transition :duration="200" origin="center top" mode="out-in">
        <router-view></router-view>
      </fade-transition>
    </div>

    <custom-footer></custom-footer>
  </div>
</template>
<script>
import { FadeTransition } from "vue2-transitions";
import CustomFooter from "@/components/Custom/CustomFooter";
import PublicStatusPageNavBar from "@/components/Custom/PublicStatusPageNavBar";
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  components: {
    FadeTransition,
    CustomFooter,
    PublicStatusPageNavBar
  },
  computed: {
    title() {
      return `${this.$route.name} Page`;
    },
    ...mapGetters("user", ["userLoggedIn"])
  }
};
</script>
<style lang="scss">
.main-content {
  margin-top: 0;
}

.navbar-horizontal .navbar-nav .nav-link .nav-link-inner--text {
  margin-left: 0;
}

$scaleSize: 0.8;
@keyframes zoomIn8 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  100% {
    opacity: 1;
  }
}

.main-content .zoomIn {
  animation-name: zoomIn8;
}

/*
.fullWidthLayout .main-content {
  padding-top: 7rem !important;
}
 */

@keyframes zoomOut8 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}

.main-content .zoomOut {
  animation-name: zoomOut8;
}

@media (min-width: 992px) {
  .navbar-horizontal .navbar-nav:not(.navbar-nav-hover) .dropdown-menu.show {
    width: 400px;
  }
}
.navbar-horizontal .navbar-brand img {
  height: 70px;
}

@media (min-width: 576px) {
  .navbar-home .navbar-collapse {
    background-color: transparent;
  }
  .navbar-horizontal.navbar-transparent .navbar-nav .nav-link {
    color: rgba(255, 255, 255, 0.95);
  }
}

.menu-sidenav-toggler {
  display: block;
}

@media (min-width: 1200px) {
  .menu-sidenav-toggler {
    display: none;
  }
}
</style>
